/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TUserReplyTemplatesModel, IMappers, TUserReplyTemplatesResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUserReplyTemplatesListResponse } from '../../entities/reply_templates/UserReplyTemplatesListResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUserReplyTemplatesModel(): TUserReplyTemplatesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/user-reply-templates/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IUserReplyTemplatesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchUserReplyTemplates<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IUserReplyTemplatesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUserReplyTemplatesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUserReplyTemplatesModel(),
    config,
  )) as FetchResponse<TUserReplyTemplatesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUserReplyTemplatesListResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUserReplyTemplatesResponse>;
}
